import {Injectable} from '@angular/core';

@Injectable()
export abstract class MapsAPILoader {
  abstract load(): Promise<void>;
}



// WEBPACK FOOTER //
// ./src/app/components/agm/core/services/maps-api-loader/maps-api-loader.ts